export default "/images/90cc9c617cbab9cb364a5cceba1f6a65.avif";